import { Set } from 'immutable'
import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('endUser/csv')

export const UPLOAD_CSV = makeConstant('UPLOAD_CSV')
export const UPLOAD_CSV_PENDING = makeConstant('UPLOAD_CSV_PENDING')
export const UPLOAD_CSV_FAILED = makeConstant('UPLOAD_CSV_FAILED')
export const UPLOAD_CSV_CANCELLED = makeConstant('UPLOAD_CSV_CANCELLED')
export const UPLOAD_CSV_SUCCESS = makeConstant('UPLOAD_CSV_SUCCESS')

export const START_CSV_IMPORT = makeConstant('START_CSV_IMPORT')
export const START_CSV_IMPORT_PENDING = makeConstant('START_CSV_IMPORT_PENDING')
export const START_CSV_IMPORT_FAILED = makeConstant('START_CSV_IMPORT_FAILED')
export const START_CSV_IMPORT_SUCCESS = makeConstant('START_CSV_IMPORT_SUCCESS')

export const CLEAR_CSV = makeConstant('CLEAR_CSV')
export const SET_MAPPING = makeConstant('SET_MAPPING')

export const SET_SELECTED = makeConstant('SET_SELECTED')
export const TOGGLE_COLUMN = makeConstant('TOGGLE_COLUMN')

export const RequiredOptions = Set(['email', 'user_id'])



// WEBPACK FOOTER //
// ./src/scripts/app/modules/csv/constants.js